import axios from "axios";
import { refreshToken } from "../service/RefreshTokenService";

const axiosInterceptor = axios.create({
    baseURL: process.env.REACT_APP_HYBRID_MODE == "true"
        ? window.location.origin + "/"
        : process.env.REACT_APP_BACKEND_BASE_URL,
    // headers: {
    //     "Content-Type": "application/json",
    // },
    withCredentials: true,
})

// Add an interceptor to attach the machine ID to every request
axiosInterceptor.interceptors.request.use(config => {
    const machineId = localStorage.getItem("machineid");
    if (machineId) {
        config.headers["X-machineId"] = machineId;
    }
    return config;
}, error => {
    return Promise.reject(error);
});

axiosInterceptor.interceptors.response.use((response) => {
    return response;
}, async function (error) {
    const originalRequest = error.config;
    if (error.response.status === 403 && !originalRequest._retry) {
        originalRequest._retry = true;
        const refreshTokenResponse = await refreshToken();
        return axiosInterceptor(originalRequest);
    }
    return Promise.reject(error);
})

export default axiosInterceptor;